<template>
  <div ref="pie_holder" class="pie_holder">
    <ClientOnly>
      <template v-if="tooltip.tooltipPosition.value.owner === tooltipId">
        <Teleport to="#teleport-tooltipchart">
          <div class="text-2xl text-Primary-800">
            <span class="font-bold">{{ hoveredData.value }} </span>
            <span class="pl-2">{{ hoveredData.value_relative }} %</span>
          </div>
          <div class="text-sm">
            {{ hoveredData.title }}
          </div>
        </Teleport>
      </template>
    </ClientOnly>
    <div class="relative md:grid grid-cols-5 gap-8 items-center">
      <div class="col col-span-3" ref="svgwrapper">
        <svg :style="{ width: size.w + 'px', height: size.h + 'px' }">
          <g
            ref="canvas"
            :transform="`translate(${size.w / 2}, ${size.h / 2})`"
          >
            <g class="slices">
              <path
                v-for="slice in slices"
                :key="slice.data.id"
                class="slice"
                :d="arcGenerator(slice)"
                :style="{ fill: colorScale(slice.data.label) }"
                :class="[
                  hoveredLegendId !== '' && hoveredLegendId !== slice.data.id
                    ? 'opacity-30'
                    : '',
                ]"
                @mouseover="mouseoverSlice($event, slice.data)"
                @mouseout="mouseoutSlice"
              ></path>
            </g>
            <g>
              <text>
                <tspan
                v-for = "(line,i) in innerText.lines"
                  x="0"
                  :y="`-${(innerText.lines.length/2)*1.2}em`"
                  :dy="`${i*1.2}em`"
                  text-anchor="middle"
                  class="text-2xl font-bold"
                >
                {{ line }}
                </tspan>
                <tspan
                  x="0"
                  :y="0"
                  :dy="`${(innerText.lines.length)*1.2}em`"
                  text-anchor="middle"
                  class="text-xs font-light"
                >
                  by project type
                </tspan>
              </text>
            </g>
          </g>
        </svg>
      </div>

      <div class="col-span-2">
        <div
          class="mt-4 md:mt0 grid grid-cols-3 md:flex md:flex-col gap-4 justify-between md:justify-start md:flex-1 pb-8"
        >
          <div class="mb-8">
            <slot name="above-legend" />
          </div>
          <div
            v-for="catName in chartData"
            :key="chartData.id"
            class="flex justify-start gap-4"
            @mouseover="hoveredLegendId = catName.id"
            @mouseleave="hoveredLegendId = ''"
          >
            <div
              :style="{ backgroundColor: colorScale(catName.label) }"
              class="w-4 h-4 shrink-0 rounded-full"
            />
            <div class="text-sm">
              {{ catName.label }}
              <span class="font-semibold">
                ({{ formatRaw(catName.value) }},
                {{ formatPercentage(catName.value_relative * 100) }}%)
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// vue version adapted from:
// http://bl.ocks.org/dbuezas/9306799
import * as d3 from "d3";
import { _Categories2Array } from "@/assets/baseTypes.js";
import { textWrap } from "d3plus-text";

function splitText(text, w, h, maxLines) {
  return textWrap()
    .height(h)
    .width(w)
    .fontSize(24)
    .lineHeight(1.3)
    .maxLines(maxLines)
    .overflow(true)(text);
}

export default {
  setup() {
    const tooltip = useTooltip();
    const svgwrapper = ref(null);
    const { width: availableWidth, height: availableHeight } =
      useElementSize(svgwrapper);
    return { tooltip, svgwrapper, availableHeight, availableWidth };
  },

  props: {
    chartData: {
      type: Array,
      default: () => {
        return [
          {
            id: "1",
            label: "Cat1",
            value: "10",
            color: "#994444",
          },
          {
            id: "2",
            label: "Cat2",
            value: "20",
            color: "#449944",
          },
          {
            id: "3",
            label: "Cat3",
            value: "30",
            color: "#444499",
          },
          {
            id: "4",
            label: "Category 4 others",
            value: "40",
            color: "#44aaaa",
          },
        ];
      },
    },
    baseSize: {
      type: Object,
      default: () => {
        return { w: 400, h: 200 };
      },
    },
    drawInlineLegend: {
      type: Boolean,
      default: false,
    },
    formatPercentage: {
      type: Function,
      default: (d) => d,
    },
    formatRaw: {
      type: Function,
      default: (d) => d,
    },
    label: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      hoverBubble: { left: null, top: null },
      hoveredData: {},
      slices: [],
      arcGenerator: null,
      outArcGenerator: null,
      colorScale: (d) => d,
      tooltipId: "piechart-tooltip",
      hoveredLegendId: "",
    };
  },
  computed: {
    size() {
      return {
        w: this.availableWidth,
        h: 400,
      };
    },
    radius() {
      return Math.min(this.size.w, this.size.h) / 2;
    },
    innerText(){
      return splitText(
              this.label,
              200,
              100,
              5
            );
    }
  },
  mounted() {
    this.initPieGenerators();
    // const svg = d3.select(this.$refs.canvas)
  },
  watch: {
    size(newValue, oldValue) {
      this.initPieGenerators();
    },
    chartData(newValue, oldValue) {
      this.initPieGenerators();
    },
  },
  methods: {
    mouseoutSlice() {
      this.tooltip.hide();
    },
    mouseoverSlice(event, item) {
      this.hoveredData = {
        title: item.label,
        value: this.$formater.salaryFormater(item.value),
        value_relative: this.$formater.intFormater(item.value_relative * 100),
      };
      this.tooltip.show(event.pageX, event.pageY, this.tooltipId, "4chart");
    },
    midAngle(d) {
      return d.startAngle + (d.endAngle - d.startAngle) / 2;
    },
    getTextTransform(d) {
      const pos = this.outerArcGenerator.centroid(d);
      pos[0] = this.radius * (this.midAngle(d) < Math.PI ? 1 : -1);
      return "translate(" + pos + ")";
    },
    getTextAnchor(d) {
      return this.midAngle(d) < Math.PI ? "start" : "end";
    },
    getPointsPolyline(d) {
      const pos = this.outerArcGenerator.centroid(d);
      pos[0] = this.radius * 0.95 * (this.midAngle(d) < Math.PI ? 1 : -1);
      return [
        this.arcGenerator.centroid(d),
        this.outerArcGenerator.centroid(d),
        pos,
      ];
    },
    initPieGenerators() {
      const pie = d3
        .pie()
        .sort(null)
        .value(function (d) {
          return d.value;
        });

      this.arcGenerator = d3
        .arc()
        .outerRadius(this.radius * 1)
        .innerRadius(this.radius * 0.6);

      this.outerArcGenerator = d3
        .arc()
        .innerRadius(this.radius * 0.9)
        .outerRadius(this.radius * 0.9);

      // const key = function (d) {
      //   return d.data.label
      // }

      const allLabels = this.chartData.map((d) => d.label);
      // move the label "others" to the beginning
      const othersIndex = allLabels.indexOf("Others");
      if (othersIndex > -1) {
        allLabels.splice(othersIndex, 1);
        allLabels.unshift("Others");
      }
      const hasOthers = allLabels.includes("Others");
      const colors = _Categories2Array.map((d) => d);
      if (!hasOthers) {
        colors.shift();
      }

      this.colorScale = d3
        .scaleOrdinal()
        .domain(allLabels)
        .range(_Categories2Array);

      this.slices = pie(this.chartData);
    },
  },
};
</script>

<style lang="scss" scoped>
.pie_holder {
  width: 100%;
  min-height: 280px;
}
path.slice:hover {
  stroke: #fff;
  stroke-width: 1px;
}

polyline {
  opacity: 0.2;
  stroke: #666;
  stroke-width: 2px;
  fill: none;
}
text.label {
  fill: #666;
}
</style>
